import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import RouterLinkButton from 'components/router-link-button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import RedeemIcon from 'components/material-symbol/icons/Redeem'
import CalendarTodayOutlinedIcon from 'components/material-symbol/icons/CalendarToday'
import ConfirmationNumberOutlinedIcon from 'components/material-symbol/icons/ConfirmationNumber'
import { useStyles } from './styles'
import { useHistory } from 'react-router-dom'

const LessonPackCardActions = ({
  isGiftable,
  onGiftClick,
  lessonType,
  remainingCredits,
  anchorEl,
  setAnchorEl,
  lessonPackId,
}) => {
  const classes = useStyles()
  const history = useHistory()

  const { coach, locations, id, deletedAt, status } = lessonType
  const locationId = locations[0].id
  const { bookingUrl } = coach
  const relativeBookingUrl =
    '/coach' +
    bookingUrl.split('/coach')[1] +
    `?lessonTypeId=${id}&locationId=${locationId}`
  const buyMoreVouchersUrl = `${relativeBookingUrl}&isLessonPacks=true`
  const bookSessionUrl = `${relativeBookingUrl}&lessonCreditBalanceQuantity=${remainingCredits}`

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = url => {
    history.push(url)
    handleMenuClose()
  }

  const handleGiftClick = () => {
    onGiftClick(lessonPackId)
    handleMenuClose()
  }

  return (
    <Grid container spacing={1} className={classes.actionContainer}>
      <Grid item xs={12} md={6}>
        {isGiftable ? (
          <Button
            onClick={() => onGiftClick(lessonPackId)}
            variant="outlined"
            color="primary"
            className={classes.actionButton}
            startIcon={<RedeemIcon />}
          >
            Gift Lessons
          </Button>
        ) : (
          <RouterLinkButton
            to={buyMoreVouchersUrl}
            variant="outlined"
            color="primary"
            className={classes.actionButton}
            style={{
              display: deletedAt || status === 'INACTIVE' ? 'none' : 'flex',
            }}
          >
            Buy Another Pack
          </RouterLinkButton>
        )}
      </Grid>
      <Grid item xs={12} md={deletedAt ? 12 : 6}>
        <RouterLinkButton
          to={bookSessionUrl}
          variant="contained"
          color="primary"
          className={classes.actionButton}
          startIcon={<CalendarTodayOutlinedIcon />}
        >
          Book a Session
        </RouterLinkButton>
      </Grid>
      {isGiftable && (
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={() => handleMenuItemClick(bookSessionUrl)}>
            <ListItemIcon>
              <CalendarTodayOutlinedIcon />
            </ListItemIcon>
            <ListItemText>Book Session</ListItemText>
          </MenuItem>
          {!deletedAt && status === 'ACTIVE' && (
            <MenuItem onClick={() => handleMenuItemClick(buyMoreVouchersUrl)}>
              <ListItemIcon>
                <ConfirmationNumberOutlinedIcon />
              </ListItemIcon>
              <ListItemText>Buy Another Pack</ListItemText>
            </MenuItem>
          )}
          <MenuItem onClick={handleGiftClick}>
            <ListItemIcon>
              <RedeemIcon />
            </ListItemIcon>
            <ListItemText>Gift Lesson Pack</ListItemText>
          </MenuItem>
        </Menu>
      )}
    </Grid>
  )
}

export default LessonPackCardActions
